"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapFiltered = void 0;
const is_defined_1 = require("../is-defined/is-defined");
/**
 * @summary Maps an array using a callback function.
 *
 * Maps an array using a callback function. If the array is `null` or `undefined`, an empty array is returned. Any
 * array item that is `null` or `undefined` will be skipped.
 *
 * @param {Array} array
 * @param {Function} callbackFn
 * @returns {Array}
 *
 * @example
 * const cleanedArray = mapFiltered(maybeDirtyArray, item => new MyObject(item));
 */
function mapFiltered(array, callbackFn) {
    return array?.filter(is_defined_1.isDefined).map(callbackFn) ?? [];
}
exports.mapFiltered = mapFiltered;
